import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import get from 'get-value';
import Input from 'shared/Inputs/Input';
import { BACKEND_DATE_FORMAT, format, hasFormat } from 'utils/date';

import InputWrapper from 'modules/af_cm_ui_kit/components/InputWrapper/InputWrapper';
import styles from './styles.module.scss';

import { Props } from './types';
import variants from './variants';
import { VARIANTS_TYPES } from './variants.types';
import { Button } from 'lmc-ui-library';

import './_TextInput.scss';

const ChangeableTextField: React.FC<Props> = ({
  field,
  type,
  placeholder,
  form,
  disabled,
  handleBlur,
  title,
  subtitle,
  readOnly,
  extraContent = [],
  variant = VARIANTS_TYPES.TEXT,
  onChangeClick,
  onClick,
  disabledButton,
}) => {
  field.value = field.value === null ? '' : field.value;

  const [initialValue, setInitialValue] = useState<string>(field.value);

  useEffect(() => {
    if (variant !== VARIANTS_TYPES.DATE) return;

    if (hasFormat(field.value, BACKEND_DATE_FORMAT)) {
      form.setFieldValue(field.name, format(field.value).fromBackendToView());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const shouldBeDisabled = disabledButton || field.value === initialValue || get(form.errors, field.name);

  const handleClick = () => {
    if (shouldBeDisabled) return;

    setInitialValue(field.value);

    return onChangeClick(field.value);
  };

  return (
    <InputWrapper
      title={title}
      name={field.name}
      subtitle={subtitle}
      hasError={false}
      wasTouched={false}
      extraContent={extraContent}>
      <div className={styles.inputContainer}>
        <Input
          field={field}
          type={type}
          className={classnames('text-input', styles.input)}
          placeholder={placeholder}
          form={form}
          disabled={disabled}
          readOnly={readOnly}
          handleBlur={handleBlur}
          {...variants.get(variant)}
          onClick={onClick}
        />

        <Button
          mode="secondary"
          borderVariant="rectangle"
          type="button"
          onClick={handleClick}
          style={{ width: 106 }}
          disabled={shouldBeDisabled}>
          Change
        </Button>
      </div>
    </InputWrapper>
  );
};

export default ChangeableTextField;
